var $87ffcbc0b651e40b$exports = {};
$87ffcbc0b651e40b$exports = {
    "close": `Zatvori`,
    "notifications": `Obavijesti`
};


export {$87ffcbc0b651e40b$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
